import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "store";
import { TermsAndConditionsStateType, TermsVersion } from "./types/termsAndConditions";

const initialState: TermsAndConditionsStateType = {
  versions: [],
  loading: false,
  error: null,
  currentFile: null,
  fileStatus: {
    loading: false,
    error: false,
    message: "",
    justUploaded: false,
  },
};

const termsAndConditionsSlice = createSlice({
  name: "termsAndConditions",
  initialState,
  reducers: {
    getTermsVersionsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getTermsVersionsSuccess: (state, action: PayloadAction<TermsVersion[]>) => {
      state.loading = false;
      state.versions = action.payload;
      state.error = null;
    },
    getTermsVersionsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    setVersions: (state, action: PayloadAction<TermsVersion[]>) => {
      state.versions = action.payload;
      state.loading = false;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },

    uploadTermsVersionRequest: (state) => {
      state.fileStatus = {
        loading: true,
        error: false,
        message: "",
        justUploaded: false,
      };
    },
    uploadTermsVersionSuccess: (state, action: PayloadAction<TermsVersion | null>) => {
      state.fileStatus = {
        loading: false,
        error: false,
        message: "",
        justUploaded: true,
      };
      state.currentFile = null;
    },
    uploadTermsVersionFailure: (state, action: PayloadAction<string>) => {
      state.fileStatus = {
        loading: false,
        error: true,
        message: action.payload,
        justUploaded: false,
      };
    },

    setCurrentFile: (state, action: PayloadAction<{ url: string; name?: string } | null>) => {
      state.currentFile = action.payload;
    },
    setFileStatus: (state, action: PayloadAction<{ 
      loading: boolean; 
      error: boolean; 
      message?: string;
      justUploaded?: boolean;
    }>) => {
      state.fileStatus = {
        ...state.fileStatus,
        loading: action.payload.loading,
        error: action.payload.error,
        message: action.payload.message !== undefined ? action.payload.message : state.fileStatus.message,
        justUploaded: action.payload.justUploaded !== undefined ? action.payload.justUploaded : state.fileStatus.justUploaded,
      };
    },

    clearFileStatus: (state) => {
      state.fileStatus = {
        loading: false,
        error: false,
        message: "",
        justUploaded: false,
      };
    },
  },
});

export default termsAndConditionsSlice.reducer;

export const actions = termsAndConditionsSlice.actions;

export const termsAndConditionsSelector = (state: RootState) => state.termsAndConditions;

